/* eslint-disable max-len */
export const TOP_CNT = {
  title: "Content Creator Verification",
  text: "Thank you for your interest in wanting to become a RedGIFs Verified Content Creator. Becoming a Verified Content Creator on RedGIFs means your profile will stand out and attract more attention. As well as this you will be able to add links to sites where users can find more of your content. To become verified please complete the following steps:",
  verifySentText: "We have received a verification request for your account. Please allow 48 hours for this to be processed before trying again. If 48 hours have passed please contact support."
};

export const VERIFY_STEPS = [
  {
    title: "Provide your links",
    index: 1,
    text: "",
    list: [
      "Please add two or more links to your social profiles; these will be displayed on your account once you are verified.",
      "To be successfully verified, at least one  link from the required section must be provided. You can then add any other required or  optional link, plus as many as you would like to see displayed on your profile."
    ]
  },
  {
    title: "Upload photo",
    index: 2,
    text: "Please ensure the photo uploaded fulfils the following requirements:",
    list: [
      "SFW photo of you holding a sign with your RedGIFs profile URL written on it, which is:",
      "Photo must be compatible with the identity that can be seen on links provided.",
      "No digitally modified images.",
      "File types supported: JPG, PNG."
    ]
  },
  {
    title: "Hit Verify Account button",
    index: 3,
    text: "You will then receive email notification to confirm your account verification."
  }
];

const TWITTER = "twitter";
const PORNHUB = "pornhub";
const INSTAGRAM = "instagram";
const MANYVIDS = "manyvids";
const REDDIT = "reddit";
const ONLYFANS = "onlyfans";
const PATREON = "patreon";
const XHAMSTER = "xhamster";
const CHATURBATE = "chaturbate";
const MYFREECAMS = "myfreecams";
const FANSLY = "fansly";
const CAMSODA = "camsoda";
const FANCENTRO = "fancentro";
const YOUTUBE = "youtube";
const DISCORD = "discord";
const FACEBOOK = "facebook";

export const LINK_REGEXP = {
  [TWITTER]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?twitter\.com/i,
    isRequired: false,
    socialKey: "socialUrl2",
    isSelected: false,
    placeholder: "https://twitter.com/"
  },
  [PORNHUB]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?pornhub\.com/i,
    isRequired: true,
    socialKey: "socialUrl1",
    isSelected: false,
    placeholder: "https://pornhub.com/model/"
  },
  [INSTAGRAM]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}instagram\.com/i,
    isRequired: false,
    socialKey: "socialUrl3",
    isSelected: false,
    placeholder: "https://instagram.com/"
  },
  [MANYVIDS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-zA-Z0-9_]+\.)?(manyvids\.com)/i,
    isRequired: true,
    socialKey: "socialUrl4",
    isSelected: false,
    placeholder: "https://manyvids.com/Profile/"
  },
  [REDDIT]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(new\.)?reddit\.com/i,
    isRequired: false,
    socialKey: "socialUrl5",
    isSelected: false,
    placeholder: "https://reddit.com/user/"
  },
  [ONLYFANS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}onlyfans\.com/i,
    isRequired: true,
    socialKey: "socialUrl6",
    isSelected: false,
    placeholder: "https://onlyfans.com/"
  },
  [PATREON]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}patreon\.com/i,
    isRequired: false,
    socialKey: "socialUrl7",
    isSelected: false,
    placeholder: "https://patreon.com/"
  },
  [XHAMSTER]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?(xhamster(4|live)?\.com)/i,
    isRequired: false,
    socialKey: "socialUrl8",
    isSelected: false,
    placeholder: "https://xhamster.com/users/"
  },
  [CHATURBATE]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(m\.)?([a-z]+\.)?chaturbate\.com/i,
    isRequired: true,
    socialKey: "socialUrl9",
    isSelected: false,
    placeholder: "https://chaturbate.com/"
  },
  [MYFREECAMS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(profiles\.|share\.){0,1}myfreecams\.com/i,
    isRequired: true,
    socialKey: "socialUrl10",
    isSelected: false,
    placeholder: "https://profiles.myfreecams.com/"
  },
  [FANSLY]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(fans\.ly|fansly\.com)/i,
    isRequired: true,
    socialKey: "socialUrl11",
    isSelected: false,
    placeholder: "https://fansly.com/"
  },
  [CAMSODA]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}camsoda\.com/i,
    isRequired: true,
    socialKey: "socialUrl12",
    isSelected: false,
    placeholder: "https://camsoda.com/"
  },
  [FANCENTRO]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}fancentro\.com/i,
    isRequired: true,
    socialKey: "socialUrl13",
    isSelected: false,
    placeholder: "https://fancentro.com/"
  },
  [YOUTUBE]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}youtube\.com/i,
    isRequired: false,
    socialKey: "socialUrl14",
    isSelected: false,
    placeholder: "https://youtube.com/"
  },
  [FACEBOOK]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}facebook\.com/i,
    isRequired: false,
    socialKey: "socialUrl15",
    isSelected: false,
    placeholder: "https://facebook.com/"
  },
  [DISCORD]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}discord\.com/i,
    isRequired: false,
    socialKey: "socialUrl16",
    isSelected: false,
    placeholder: "https://discord.com/users/"
  },
};
